var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLookup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90909 20.0456L5.18182 17.1365L1.90909 16.4092L2.22727 13.0456L0 10.5001L2.22727 7.95467L1.90909 4.59103L5.18182 3.86376L6.90909 0.954666L10 2.27285L13.0909 0.954666L14.8182 3.86376L18.0909 4.59103L17.7727 7.95467L20 10.5001L17.7727 13.0456L18.0909 16.4092L14.8182 17.1365L13.0909 20.0456L10 18.7274L6.90909 20.0456ZM7.68182 17.7274L10 16.7274L12.3636 17.7274L13.6364 15.5456L16.1364 14.9547L15.9091 12.4092L17.5909 10.5001L15.9091 8.54558L16.1364 6.00012L13.6364 5.45467L12.3182 3.27285L10 4.27285L7.63636 3.27285L6.36364 5.45467L3.86364 6.00012L4.09091 8.54558L2.40909 10.5001L4.09091 12.4092L3.86364 15.0001L6.36364 15.5456L7.68182 17.7274ZM9.04545 13.7274L14.1818 8.59103L12.9091 7.27285L9.04545 11.1365L7.09091 9.22739L5.81818 10.5001L9.04545 13.7274Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookup);
export default __webpack_public_path__ + "static/media/lookup.6eb6bb25a0337ae1a051892c13588ec2.svg";
export { ForwardRef as ReactComponent };